import React from 'react'
import BigBox from '../ad_types/BigBox'
import TSCAdComponent from '../ad_types/TSCAdComponent'
import CalReply from '../calreply/CalReply'
import CalReplyPlayoff from '../CalReplyPlayoff/CalReplyPlayoff'
import SidebarHeadlines from './../../components/headlines/sidebar/SidebarHeadlines'
import zonePosts from './../../components/zone_posts/zonePosts'

import SNHeader from './../../components/sn_header/SNHeader'
import { MedalTable } from '@digitalmedia/sn-design-system'
import useIsMobile from 'context/IsMobileContext'

import './Sidebar.scss'

export default function Sidebar(props) {
    const { league, page, year } = props
    const { isMobileApp } = useIsMobile()
    let Headlines = null

    if (league === 'chl') {
        Headlines = zonePosts('memorial-cup', 'headlines')(SidebarHeadlines)
    }
    if (league === 'wjc') {
        Headlines = zonePosts('world-juniors', 'headlines', 10)(SidebarHeadlines)
    }
    if (league === 'whc') {
        Headlines = zonePosts('whc', 'headlines', 10)(SidebarHeadlines)
    }
    if (league === 'wwhc') {
        Headlines = zonePosts('wwhc', 'headlines', 10)(SidebarHeadlines)
    }
    if (league === 'euro') {
        Headlines = zonePosts('euro', 'headlines')(SidebarHeadlines)
    }
    if (league === 'wnba') {
        Headlines = zonePosts('wnba', 'headlines')(SidebarHeadlines)
    }
    if (league === 'natl') {
        Headlines = zonePosts('fifa-world-cup', 'headlines', 10)(SidebarHeadlines)
    }
    if (league === 'wwc') {
        Headlines = zonePosts('womens-world-cup', 'headlines', 10)(SidebarHeadlines)
    }
    if (league === 'wbc') {
        Headlines = zonePosts('wbc', 'headlines', 10)(SidebarHeadlines)
    }

    return (
        <div>
            {league === 'oly' && (
                <div className="oly_sidebar__cont">
                    <SNHeader type="secondary">Medal Tracker</SNHeader>
                    <MedalTable
                        year={year}
                        footerLinks={[
                            { text: 'Full Medals Table', url: `/olympics/medal-table/${year}` },
                        ]}
                    />
                </div>
            )}

            <BigBox bg={false} view={'all'} visible={true} refresh={false} />
            {!isMobileApp && league === 'chl' && <Headlines postHeader="Memorial Cup" noThumb />}
            {!isMobileApp && league === 'euro' && <Headlines postHeader="Euro" noThumb />}
            {!isMobileApp && league === 'natl' && <Headlines postHeader="World Cup 2022" noThumb />}
            {!isMobileApp && league === 'wwc' && (
                <Headlines postHeader="Women's World Cup" noThumb />
            )}
            {!isMobileApp && league === 'wjc' && <Headlines postHeader="World Juniors" noThumb />}
            {!isMobileApp && league === 'wnba' && <Headlines postHeader="WNBA" noThumb />}
            {!isMobileApp && league === 'whc' && (
                <Headlines postHeader="World Hockey Championship" noThumb />
            )}
            {!isMobileApp && league === 'wwhc' && <Headlines postHeader="WWHC" noThumb />}
            {!isMobileApp && league === 'wbc' && (
                <Headlines postHeader="World Baseball Classic" noThumb />
            )}
            {(league === 'nhl' || league === 'mlb' || league === 'nba') &&
                page === 'Scoreboard' && <CalReply league={league} type="league" />}
            {(league === 'nhl' || league === 'nba' || league === 'mlb') && page === 'Playoffs' && (
                <CalReplyPlayoff league={league} type="league" />
            )}
            <TSCAdComponent league={props.league} />
        </div>
    )
}
